module.exports = __webpack_public_path__ + "static/media/img-03.2815135a.jpg";